/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuFilters_viewer = {|
  +isMatchedSetsEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilters_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMatchedSetsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"enableMatchedSetsFacet\"}"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
